<script>
import List from '@/components/List/List.vue'
import Form from '@/components/Form/Form.vue'
import PopUp from '@/components/PopUp.vue'
import TextEditor from '@/components/TextEditor.vue'
import message from '@/helpers/message'
export default {
    components: { List, Form, PopUp, TextEditor },
    created() {
        this.$cache.createCache('userOwnerCourses', 'user-owner-courses/') 
    },
    data() {
        return {  
            editItem: null,        
            approveItem: null, 
            emailItem: null,       
            smsItem: null,       
            columns: [         
                { name: 'not_approved', displayName: '<i class="fa-solid fa-person-circle-check color-black"></i>', icon: 'fa-solid fa-person-circle-check', onlyShowIfTrue: true, function: this.approveParticipant, align:'center', width: 30, title: 'Godkänn anmälan', hideFilter: true, hideIfEdit: true},    
                { name: 'edit', displayName: '<i class="fa-solid fa-pen color-black"></i>',  title: 'Redigera', icon: 'fa-solid fa-pencil', align:'center', function: this.edit, width: 25, hideFilter: true, hideIfEdit: true},
                { name: 'delete', displayName: '<i class="fa-solid fa-trash color-black"></i>', isDelete: true, align:'center', width: 30, title: 'Ta bort anmälan', hideFilter: true, hideIfEdit: true},    
                { name: 'full_name', displayName: 'Namn', width: 270, hideFilter: true},         
                { name: 'approved', displayName: 'Är godkänd', align: 'center', width: 110, hideFilter: true, isBoolean: true },
                { name: 'has_paid', displayName: 'Har betalt', align: 'center', width: 110, hideFilter: true, isBoolean: true },
                { name: 'email', displayName: 'Email', width: 200, hideFilter: true },
                { name: 'mobile_no', displayName: 'Mobilnummer', width: 200, hideFilter: true}
            ],
            form: [                   
                { sections: [
                    { sectionName: 'Deltagarinformation', classes: "g-100", inputs: [
                        { type: 'text', prop: 'full_name', title: 'Namn', classes: "g-100", required: true }, 
                        { type: 'text', prop: 'email', title: 'Email', classes: "g-50" }, 
                        { type: 'text', prop: 'mobile_no', title: 'Mobilnummer', classes: "g-50" }, 
                        { type: 'switch', prop: 'approved', title: 'Godkänd', classes: "g-50" },                          
                        { type: 'switch', prop: 'has_paid', title: 'Har betalt avgiften', classes: "g-50" }                           
                        ]
                    }]
                }],
            formEmail: [                   
                { sections: [
                    { sectionName: 'Skicka Email till deltagarna', classes: "g-100", inputs: [
                        { type: 'text', prop: 'subject', title: 'Titel', classes: "g-100", required: true }, 
                        { type: 'textEditor', prop: 'body', title: 'Text', classes: "g-100", required: true }, 
                                                 
                        ]
                    }]
                }],
            formSms: [                   
                { sections: [
                    { sectionName: 'Skicka SMS till deltagarna', classes: "g-100", inputs: [                     
                        { type: 'textAreaSms', prop: 'body', title: 'Text', classes: "g-100", required: true }, 
                                                 
                        ]
                    }]
                }],
        }
    },
    methods: {
        add() {
            this.editItem = { id: 0, full_name: null, email: null, mobile_no: null, approved: true, has_paind: false, course_id: this.course.id }
        },
        edit(item) {
            this.editItem = item;
        },
        getUserOwnerCourses() {
            this.editItem = null;
            this.$cache.updateCache('userOwnerCourses', 'user-owner-courses/');
       },
       remove(id)
        {
            var self = this;
            this.$communicator.post('course-participant/' + id + '/delete')
                .then(function(data)
                {                 
                    self.getUserOwnerCourses();
                    message.setSuccessMessage('Personen är nu borttagen från kursen.');
                })
                .fail(function(error) {                  
                })  
        },
        approveParticipant(item) {
            item.subject = this.customer.name +  ' - Välkommen till kursen ' + this.course.name;
            item.body = '<h2>Hej ' + item.full_name + '!</h2><br>Du är anmäld till kursen "' + this.course.name + '" som inleds ' + this.course.course_start + '<br>Vi återkommer med mer information när det närmar sig kursstart.<br>//varma hälsningar ' + this.customer.name ;
            item.no_email = false;
            this.approveItem = item;
        },
        setNoEmailAndSaveApproveParticipant() {
            this.approveItem.no_email = true;
            this.saveApproveParticipant();
        },
        saveApproveParticipant()
        {
            var self = this;
            this.$communicator.post('approve-course-participant', this.approveItem)
                .then(function(data)
                {                 
                    self.getUserOwnerCourses();
                    message.setSuccessMessage('Härligt! Personen är nu godkänd som deltagare i kursen.');
                    self.approveItem = null;
                })
                .fail(function(error) {                  
                })  
        },
        backToCourse(){
            this.$router.push({ name: 'ownerCourses' })
        },
        sendEmailSuccess() {
            this.emailItem = null;
        },
        sendSmsSuccess() {
            this.smsItem = null;
        }
    },
    computed: {
        course() {  return this.$store.state.userOwnerCourses == null ? null : this.$store.state.userOwnerCourses.find(x => x.id == this.$route.params.id); },
        courseIsFull() { return this.course.max_number_of_participents - this.course.participants.filter(x => x.approved).length == 0; },
        customer() { return this.$store.state.customer; }   
    }
}
</script>
<template>
    <div v-fade-in v-if="course != null">
        <main class="opacity-white-bg">  
            <button class="btn btn-gray float-right" @click="backToCourse">Tillbaka till dina kurser</button>    
            <h2>{{this.course.name }}</h2>                     
            <div class="OwnerCourses-wrapper">  
                <h3>
                    Deltagarlista, 
                    <span v-if="courseIsFull">Kursen är fullbokad</span>
                    <span v-else>
                     {{ course.max_number_of_participents - course.participants.filter(x => x.approved).length }} av {{ course.max_number_of_participents }} platser lediga
                    </span>
                </h3> 
                <button v-if="!courseIsFull" class="btn float-right" @click="add">Lägg till deltagare</button>
                <button class="btn btn-gray float-right" @click="emailItem = { subject: 'Emailutskick från ' + customer.name + ', ' +  course.name, body: '', course_id: course.id}">Skicka Email till deltagarna</button>
                <button v-if="customer.enable_sms_notification" class="btn btn-gray float-right" @click="smsItem = { body: 'Sms från '+ customer.name+' , ' +  course.name , course_id: course.id, is_sms: true }">Skicka SMS till deltagarna</button>
                <List :items="course.participants" :deleteFunction="remove" :columns="columns" :nameOfItems="'deltagare'" :height="400" :noOfFrozenColumns="3" :hideExcelExport="true"></List> 
            </div>
        </main>
        <div v-if="editItem != null">
            <PopUp>
            <Form :form="form" :item="editItem" :url="'course-participant/'" :getItemFunction="getUserOwnerCourses" :inEditMode="true"></Form>
            </PopUp>
        </div>
        <div v-if="approveItem != null">
            <PopUp :width="'1000px'">
                <div class="OwnerCourses-approve-wrapper">
                    <h2>Godkänn och skicka ut välkomstmail</h2>
                    <p>Följande välkomstmail kommer skickas ut till {{ approveItem.full_name  }}. Notera att detta bara är ett förslag,
                         du har full möjlighet att ändra både Ämnesraden och innehållet i mailet genom att använd formuläret nedan.
                         <br><br><i> Om du bara vill godkänna utan att skicka välkomstmail,
                         klicka på knappen 'Godkänn utan att skicka välkomstmail' nedan.</i>
                    </p>

                    <label>Ämne</label>
                    <input type="text" v-model="approveItem.subject" />
                    <label>Innehåll</label>
                    <TextEditor :model="approveItem" :prop="'body'" :height="'400px'"></TextEditor>
                    <div class="float-right">
                        <button class="btn btn-gray" @click="approveItem = null">Avbryt</button>   
                        <button class="btn btn-gray" @click="setNoEmailAndSaveApproveParticipant">Godkänn utan att skicka välkomstmail</button>   
                        <button class="btn" @click="saveApproveParticipant">Godkänn och skicka</button>   
                    </div>
                </div>
            </PopUp>
        </div>
        <div v-if="emailItem">
            <PopUp>
                <Form :form="formEmail" :item="emailItem" :url="'course-send-message/'" :getItemFunction="sendEmailSuccess" :inEditMode="true"></Form>
            </PopUp>
        </div>
        <div v-if="smsItem">
            <PopUp>
                <Form :form="formSms" :item="smsItem" :url="'course-send-message/'" :getItemFunction="sendSmsSuccess" :inEditMode="true"></Form>
            </PopUp>
        </div>
    </div>
</template>
<style scoped>
    .OwnerCourses-approve-wrapper {
        text-align: left;
    }
    .OwnerCourses-wrapper
    {
        background-color: white;
        padding: 5px 15px;
        border-radius: 10px;
        overflow: auto;
    }  

    label {
        font-weight: 500;
        margin-top: 19px;
        margin-bottom: 5px;
        display: block;
        text-transform: uppercase;
        font-size: 15px;
    }

    h3 {
        text-transform: none;
    }

    @media only screen and (max-width: 1000px) {
        
    }
</style>